// extracted by mini-css-extract-plugin
export default {"header":"Title_header__jhcGa","left":"Title_left__hSxv0","image":"Title_image__9cfr1"};